import {type MutationTree} from 'vuex';

const mutations: MutationTree<LightBoxState> = {

    setImages(state, images)
    {
        state.images = images;
        state.count = images.length;
    },

    setCurrent(state, current)
    {
        state.current = current;
    },

};

export default mutations;